import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledConceptRaceFinalFeedback = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .title {
    font-size: ${(props) => Math.max(32, props.stage.width * 0.04)}px;

    &.success {
      color: ${Colors.success};
    }
  }
  .subtitle {
    text-align: center;
    font-size: ${(props) => Math.max(24, props.stage.width * 0.03)}px;
  }

  .correction-desc {
    font-size: ${(props) => Math.max(18, props.stage.width * 0.02)}px;
  }

  .corrections {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .correction-desc {
      margin: 2% 0;
      text-align: center;
    }
    .corrections-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin: 0 1%;
      grid-gap: 3%;

      .concept-correction {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        height: ${({ conceptHeight }) => conceptHeight}px;
        .concept-correction-name {
          font-size: ${(props) => props.stage.width * 0.02}px !important;
        }
        .concept-animation {
          cursor: pointer;
          width: 40%;
          height: ${({ conceptHeight }) => conceptHeight}px;
          display: flex;
          justify-content: flex-end;
        }
        .concept-text {
          cursor: pointer;
          width: 60%;
        }
      }
    }
  }
`;
